import { motion } from "framer-motion";
import React from "react";
import { useNavigate } from "react-router-dom";

import {
  Button,
  FloatingLabelInput,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormMessage,
  RedirectMessage,
  TRedirectStatus,
} from "@/components";
import { useI18n } from "@/context";

import { useResetPassword } from "./reset-password.hooks";
export const ResetPassword: React.FC = () => {
  const {
    form,
    handleResetPassword,
    resetStatus,
    redirectMessageRef,
    resetData,
  } = useResetPassword();
  const { t } = useI18n();
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen items-center justify-center p-4 bg-background">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="w-full max-w-md space-y-6 bg-background/80 p-8 shadow-lg border border-muted/20"
      >
        <div className="flex flex-col items-center space-y-2 text-center">
          <h1 className="font-semibold mb-3 text-2xl">
            {t("auth.resetPassword")}
          </h1>
          <p className="text-sm text-muted-foreground mb-3">
            {t("auth.resetPasswordDescription")}
          </p>
        </div>
        <Form {...form}>
          <form
            className="space-y-4"
            onSubmit={form.handleSubmit(handleResetPassword)}
          >
            <FormField
              control={form.control}
              name="password"
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <FloatingLabelInput
                      type="password"
                      label={t("auth.password")}
                      placeholder={t("auth.password")}
                      {...field}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="confirmPassword"
              render={({ field }) => (
                <FormItem>
                  <FormControl>
                    <FloatingLabelInput
                      type="password"
                      label={t("auth.confirmPassword")}
                      placeholder={t("auth.confirmPassword")}
                      {...field}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <div className="flex flex-col  gap-4 mt-4">
              <Button className="bg-primary dark:text-foreground/100 w-full">
                {t("generic.confirm")}
              </Button>
              <Button
                className="w-full"
                variant="outline"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/auth/login");
                }}
              >
                {t("generic.cancel")}
              </Button>
            </div>
          </form>
        </Form>
      </motion.div>
      <RedirectMessage
        ref={redirectMessageRef}
        redirectFunction={
          resetData[resetStatus as keyof typeof resetData].function
        }
        message={resetData[resetStatus as keyof typeof resetData].message}
        redirectTime={resetData[resetStatus as keyof typeof resetData].time}
        type={resetStatus as TRedirectStatus}
      />
    </div>
  );
};
